export enum ExpertiseRatingEnum {
  AboveAverage = 1,
  Average = 2,
  BelowAverage = 3,
}
